import type { IllustrationProps } from './types';
import {
  ILLUSTRATION_PALETTE,
  IllustrationSvg,
  SkyBackdrop,
  SlopeSurface,
  TractorFigure,
  WarningDot,
} from './shared';

export default function TractorImpossibleIllustration({
  className,
  width,
  height,
  primaryColor,
  accentColor,
}: IllustrationProps) {
  const accent = accentColor ?? ILLUSTRATION_PALETTE.impossible;

  return (
    <IllustrationSvg className={className} width={width} height={height} title="İş makinesi çıkamıyor">
      <SkyBackdrop accent={accent} />
      <SlopeSurface startY={50} endY={10} accent={accent} />
      <TractorFigure cx={40} cy={6} tilt={-26} slip primary={primaryColor} />
      <WarningDot x={60} y={8} />
    </IllustrationSvg>
  );
}
